import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Chip from '@/ui/chips/chip/Chip';
import ComponentPreloader from '@/ui/preloaders/componentPreloader/ComponentPreloader';
import ESGdimension from '@/data/esgDimensionmap.json';
import Nodata from '@/ui/errorSigns/noData/Nodata';
import NewsCardSmall from '@/ui/card/newsCards/image/newsCardSmall/NewsCardSmall';
import PrimaryMenu from '@/ui/menus/primaryMenu/PrimaryMenu';
import Pagination from '@/ui/pagination/Pagination';
import { Container, MenuWrapper, ChipWrapper, CardWrapper, NewsWrapper } from './EsgNewsStyles';

interface EsgNewsProps {
  dimensions?: any;
  esgNewsMenu?: any;
  articles?: any;
  totalN?: any;
  page?: any;
  handlePage?: (page: number) => void;
  handleMenu?: any;
  isLoading?: any;
}

const EsgNews = ({
  dimensions,
  esgNewsMenu,
  articles,
  totalN,
  page,
  handlePage,
  handleMenu,
  isLoading,
}: EsgNewsProps) => {
  const language = useSelector((state: any) => state.user.language);
  const [t] = useTranslation('noData');
  return (
    <div className="space-y-12">
      <MenuWrapper>
        <PrimaryMenu
          menuList={dimensions}
          mode="fill"
          activeIndex={esgNewsMenu.selectedDimension}
          onClick={(index) => handleMenu(index, 0)}
        />
        <ChipWrapper>
          {ESGdimension[esgNewsMenu.selectedDimension].GIC.map((gic, i) => (
            <Chip
              key={i}
              selected={i === esgNewsMenu.selectedGic}
              onClick={() => handleMenu(esgNewsMenu.selectedDimension, i)}
            >
              {gic[`GIC_Name_${language}`]}
            </Chip>
          ))}
        </ChipWrapper>
      </MenuWrapper>

      {!isLoading ? (
        <>
          <div className="w-full sm:grid sm:grid-cols-2 gap-4">
            {articles.map((article, i) => (
              <div key={i}>
                <NewsCardSmall article={article} />
              </div>
            ))}
          </div>
          {articles.length === 0 ? <Nodata desc={t('No ESG news.')} /> : null}
        </>
      ) : (
        <ComponentPreloader width="1206px" height="300px" />
      )}

      {!isLoading && (
        <Pagination
          totalPage={Math.ceil(totalN / 20)}
          currentPage={page}
          step={5}
          onClick={handlePage}
        />
      )}
    </div>
  );
};

export default EsgNews;
